const loadSettings = (stage, settingsType) => import(`../settings/${stage}/${settingsType}.json`).then((res) => res.default);
export { loadSettings };
//# sourceMappingURL=loadSettings.js.map